import React, { useCallback, useContext, useState } from 'react'
import styled from 'styled-components'
import { MARGIN } from '../constants'
import { AppContext } from '../context'
import { closeButton, dndButton, peaceOnboardingAnimation, upEmoji } from '../img/images'
import { ThinArrow } from './categories'
import { Code, Download } from './overlay-icons'

const Container = styled.div`
    border-radius: 4px;
    margin: 0 ${MARGIN}px ${MARGIN}px ${MARGIN}px;
    padding: ${MARGIN}px 0;
    display: flex;
    background-image: linear-gradient(45deg, #5c6fff 0%, #9345fa 100%);
    font-family: interface;
    font-size: 13px;
    line-height: 19px;
    user-select: none;
`

const Close = styled.img`
    align-self: flex-start;
    padding: 0 10px;
    margin-left: 5px;
    cursor: pointer;
`

const Next = styled.div`
    align-self: center;
    padding: 0 10px;
    margin-left: 10px;
    cursor: pointer;
`

const UpEmoji = styled.img`
    object-fit: contain;
    padding: 0 10px;
    transform: translateY(-25px);
`

const PeaceOnboardingAnimation = styled.img`
    object-fit: contain;
    padding: 2px 5px;
`

const SCCode = styled(Code)`
    transform: translateY(2px);
    margin: 10px;
    width: 30px;
    height: 30px;
`

const SCDownload = styled(Download)`
    transform: translateY(2px);
    margin: 10px;
    width: 30px;
    height: 30px;
`

const DnD = styled.img`
    object-fit: contain;
    padding: 0 10px;
`

export const TextMessage = () => {
    const { searchMode, seenMessage, setSeenMessage } = useContext(AppContext)
    // const { term } = useContext(SearchContext)
    const show = !seenMessage('giphyText') && searchMode === 'text'
    return show ? (
        <Container>
            <UpEmoji src={upEmoji} width={25} height={57} />
            <div>
                <b>Introducing GIPHY Text</b>
                <div>Give it a try. Just search to create your very own Text Stickers!</div>
            </div>
            <Close src={closeButton} height={17} width={17} onClick={() => setSeenMessage('giphyText', true)} />
        </Container>
    ) : null
}

export const EmojiVariationsMessage = () => {
    const { searchMode, seenMessage, setSeenMessage } = useContext(AppContext)
    const show = !seenMessage('emojiVariations') && searchMode === 'emoji'

    return show ? (
        <Container>
            <PeaceOnboardingAnimation src={peaceOnboardingAnimation} width={32} height={32} />
            <div>
                <b>Skin tones and themes! </b>
                <div>Now available for more emojis than ever!</div>
            </div>
            <Close src={closeButton} height={17} width={17} onClick={() => setSeenMessage('emojiVariations', true)} />
        </Container>
    ) : null
}

type OnboardProps = { next: () => void }
const Onboard1 = ({ next }: OnboardProps) => {
    return (
        <>
            <DnD src={dndButton} width={25} />
            <div>
                <b>Welcome to the GIPHY Extension!</b>
                <div>You can drag and drop GIFs and stickers directly to websites that support drag and drop.</div>
            </div>
            <Next onClick={() => next()}>
                <ThinArrow />
            </Next>
        </>
    )
}

const Onboard2 = ({ next }: OnboardProps) => {
    return (
        <>
            <SCCode />
            <div>
                <b>HTML embed code</b>
                <div>You can always grab the html embed code by clicking the &#60;/&#62; when hovering a GIF</div>
            </div>
            <Next onClick={() => next()}>
                <ThinArrow />
            </Next>
        </>
    )
}

const Onboard3 = () => {
    const { setSeenOnboard } = useContext(AppContext)
    return (
        <>
            <SCDownload />
            <div>
                <b>Download</b>
                <div>
                    Click the download icon to download to your computer.
                    <div>
                        Click the <b>X</b> to close this tutorial.
                    </div>
                </div>
            </div>
            <Close src={closeButton} height={17} width={17} onClick={() => setSeenOnboard(true)} />
        </>
    )
}

export const OnboardDialog = () => {
    const [page, setPage] = useState(0)
    const Message1 = useCallback(() => <Onboard1 next={() => setPage(page + 1)} />, [page, setPage])
    const Message2 = useCallback(() => <Onboard2 next={() => setPage(page + 1)} />, [page, setPage])
    const Message3 = useCallback(() => <Onboard3 />, [])
    let Message = Message1
    switch (page) {
        case 1:
            Message = Message2
            break
        case 2:
            Message = Message3
            break
        default:
            break
    }
    return (
        <Container>
            <Message />
        </Container>
    )
}
